import type { ChangeEvent, ForwardedRef } from 'react';
import { forwardRef, useState } from 'react';
import { Checkbox } from '../Checkbox/Checkbox';
import { StyledCheckboxGroupRoot } from './CheckboxGroup.styled';
import type { CheckboxGroupCheckbox, CheckboxGroupProps } from './CheckboxGroup.types';

export const CheckboxGroup = forwardRef(
  <T extends CheckboxGroupCheckbox[]>(
    { value, styledComponents, checkbox, onChange, onValuesChange, ...props }: CheckboxGroupProps,
    ref: ForwardedRef<HTMLInputElement>,
  ) => {
    const [status, setStatus] = useState<T[number]['value'][]>(value || []);

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      const changedValue = checkbox
        .map((el) => el.value)
        .filter((el) => {
          if (el === e.target.value) return e.target.checked;
          return status.includes(el);
        });

      if (onChange) {
        onChange(e);
      }
      if (onValuesChange) {
        onValuesChange(changedValue);
      }
      setStatus(changedValue);
    };

    return (
      <StyledCheckboxGroupRoot {...styledComponents?.root}>
        {checkbox?.map((el) => (
          <Checkbox
            defaultChecked={value?.includes(el.value)}
            key={el.value}
            onChange={handleChange}
            {...el}
            styledComponents={styledComponents?.checkbox}
            {...props}
            ref={ref}
          />
        ))}
      </StyledCheckboxGroupRoot>
    );
  },
);
